module.exports = __webpack_public_path__ + "img/30.2755f63e.jpg";